import { checkStoragePermission } from "./utils/permission.js";
checkStoragePermission();

import { createApp } from "vue";
import "./style.css";
// import Adjust from '@adjustcom/adjust-web-sdk'
import {requestViewStatistics} from "./utils/adjust_manager.js";
import * as Sentry from "@sentry/vue";
import {
  checkPlatform,
  isAndroid,
  isChrome,
  isInFacebook,
  isInStandaloneMode,
  isMobileDevice,
  openByChrome,
  openChromeDownloadPage,
} from "./utils/pwa";
import { showGiftDialog, installProgress } from "./app.js";
import App from "./App.vue";
import { pwaHomePageUrl } from "./global.js";
import { getUUID } from "./utils/uuid.js";
if (location.protocol === "http:") {
  location.href = location.href.replace("http:", "https:");
}

checkPlatform();


if (isChrome) {

    location.href = "/";
  
}
setTimeout(()=>{
  requestViewStatistics(location.href);
},500)
if (!isInStandaloneMode()) {
  if (!isMobileDevice()) {
    //显示二维码
  } else {
    if (isChrome && isAndroid) {
      let timerId = setTimeout(() => {
        if (installProgress.value == 0) {
          showGiftDialog.value = true;
        }
        clearTimeout(timerId);
      }, 5000);
    } else {
      if (!isChrome&&!isInFacebook()) {
        openByChrome();
        let timerId = setTimeout(() => {
          openChromeDownloadPage();
          clearTimeout(timerId);
        }, 2000);
      }
    }
    // Show gift dialog after app is mounted
  }
}
const app = createApp(App);
Sentry.init({
  app,
  dsn: "https://a9eee8f1b757a3f4d3ae31c61a6bef76@o4508974751481856.ingest.us.sentry.io/4508974752464896",
  integrations: [Sentry.replayIntegration()],

  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  environment: process.env.NODE_ENV,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/*\.io/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
setTimeout(()=>{
  Sentry.captureMessage(`intall page ${getUUID()} referrer:${window.document.referrer} ${location.href}`, "info");

},200)
// Sentry.captureMessage(`Sentry.inited${getUUID()} ${location.href.slice(-30)}`,'info')
console.log("Sentry.inited");
app.mount("#app");

// createApp(App).mount('#app') // This line is removed as it's redundant and can cause issues
